import { ErrorTwoTone } from '@mui/icons-material';
import {
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Stack,
} from '@mui/material';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { IGuideTourAccommodationGroupSettledList } from '../utils/types';
import { AgeGroupIcon } from './AgeGroupIcon';

type GuideTourAccommodationRoomGroupTableProps = {
  accommodationGroupSettledList: IGuideTourAccommodationGroupSettledList[];
};

const GuideTourAccommodationRoomGroupTable: React.FC<
  GuideTourAccommodationRoomGroupTableProps
> = ({ accommodationGroupSettledList }) => {
  const groupedContent: Record<
    string,
    IGuideTourAccommodationGroupSettledList[]
  > = {};

  accommodationGroupSettledList.forEach((item) => {
    const groupId = item.roomGroupId;
    if (!groupedContent[groupId]) {
      groupedContent[groupId] = [];
    }
    groupedContent[groupId].push(item);
  });
  const { t } = useTranslation();

  return (
    <List>
      {Object.entries(groupedContent)
        .sort((a, b) => (a[0] === 'null' ? -1 : 0))
        .map(([groupId, group], index, arr) => (
          <Fragment key={groupId}>
            <ListSubheader>
              {groupId === 'null' ? (
                <Stack direction="row" gap={1} alignItems="center">
                  <ErrorTwoTone fontSize="small" color="error" />
                  {t('GuidanceTourAccommodationPage.waitingForRooming')}
                </Stack>
              ) : (
                `${group[0].roomType} - ${group[0].bedType} ${t(
                  'GuidanceTourAccommodationPage.roomNumber',
                  {
                    roomNumber: group[0].roomNumber || 'Belirlenmemiş',
                  },
                )}`
              )}
            </ListSubheader>
            {group.map((item, index) => (
              <ListItem key={item.id}>
                <ListItemIcon>
                  <AgeGroupIcon
                    startMonths={item.startAgeInMonth}
                    gender={item.gender as 'MALE' | 'FEMALE'}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={item.customerFullName}
                  secondary={
                    <>
                      {t('GuidanceTourAccommodationPage.age', {
                        age: item.age,
                      })}
                      <br />
                      {item.salesOrderOffice}
                    </>
                  }
                />
              </ListItem>
            ))}
            {index < arr.length - 1 && <Divider />}
          </Fragment>
        ))}
    </List>
  );
};

export default GuideTourAccommodationRoomGroupTable;
